import { useState } from 'react';
import { AIConfig } from '@g17eco/types/ai';
import { SettingStorage } from '@services/SettingStorage';
import { safeJsonParse } from '@utils/json';

export const useAIInstructionsForm = ({ storageKey }: { storageKey: string }) => {
  const loadFromStorage = () => {
    const { additionalContext, aiModel } = safeJsonParse<AIConfig>(SettingStorage.getItem(storageKey), {
      additionalContext: '',
    });

    return { additionalContext, aiModel };
  };

  const [form, setForm] = useState<AIConfig>(loadFromStorage());

  const onChangeForm = (data: Partial<AIConfig>) => {
    setForm((prev) => {
      return { ...prev, ...data };
    });
  };

  const saveToStorage = () => {
    const trimmedContext = form.additionalContext.trim();

    if (form.additionalContext !== trimmedContext) {
      onChangeForm({ additionalContext: trimmedContext });
    }

    SettingStorage.setItem(storageKey, JSON.stringify({ ...form, additionalContext: trimmedContext }));
  };

  return { form, onChangeForm, saveToStorage };
};
